export default __webpack_public_path__ + "static/media/20210501_103940-min.d315ce13.jpg";